import React from 'react'

import css from '@styled-system/css'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { system, variant } from 'styled-system'

import Box from '@/ui/Box'
import Span from '@/ui/Span'

const Base = styled(Box)(
  system({
    stroke: {
      property: 'stroke',
      scale: 'colors',
    },
    fill: {
      property: 'fill',
      scale: 'colors',
    },
  }),
)

export const Path = styled(Base).attrs({
  as: 'path',
})``
export const Circle = styled(Base).attrs({
  as: 'circle',
})``
export const Rect = styled(Base).attrs({
  as: 'rect',
})``
export const Ellipse = styled(Base).attrs({
  as: 'ellipse',
})``
export const Line = styled(Base).attrs({
  as: 'line',
})``
export const Mask = styled(Base).attrs({
  as: 'mask',
})``
export const G = styled(Base).attrs({
  as: 'g',
})``

export const iconSizes = {
  xxs: {
    height: '12px',
    width: '12px',
  },
  xs: {
    height: '16px',
    width: '16px',
  },
  sm: {
    width: '20px',
    height: '20px',
  },
  md: {
    height: '24px',
    width: '24px',
  },
  lg: {
    height: '32px',
    width: '32px',
  },
  xl: {
    height: '48px',
    width: '48px',
  },
  xxxl: {
    height: '64px',
    width: '64px',
  },
}

export const IconBaseStyled = styled(Span)(
  variant({
    prop: '$size',
    variants: iconSizes,
  }),
  ({ height, width, zIndex, justifyContent }) =>
    css({
      display: 'inline-flex',
      flexShrink: 0,
      height: height,
      width: width,
      zIndex: zIndex ?? 0,
      justifyContent: justifyContent ?? 'center',
    }),
)

const IconBase = ({
  children,
  cursor,
  viewBox = '0 0 24 24',
  size = 'sm',
  ...props
}) => {
  return (
    <IconBaseStyled $size={size} {...props}>
      <svg viewBox={viewBox} xmlns='http://www.w3.org/2000/svg' cursor={cursor}>
        {children}
      </svg>
    </IconBaseStyled>
  )
}

IconBase.propTypes = {
  children: PropTypes.any,
  viewBox: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxxl']),
    ),
    PropTypes.number,
    PropTypes.string,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  cursor: PropTypes.string,
}

export default IconBase
